Controller = App.loadClass 'core::Angular/Controller'

class exports.StatusController extends Controller
    constructor: (@scope, @transitions, @state, @modal, @mcs, @loader) ->
        super(@scope, @transitions)
        @scope.$emit 'data_fullpage:hide'
        setTimeout () =>
            @scope.$emit 'data_fullpage:show'
            $(window).trigger 'resize'
        , 500
        @loader.overMap 'Loading...'
        @scope.mcs = @mcs

        @scope.clear_selections = []
        @scope.cant_clear = ['Uploading', 'Processing', 'Converted']
        @scope.bulkClearing = false
        @scope.selectedAll = false
        @scope.clearBtnText = 'Bulk Clear'
        @scope.selectBtnText = 'Select All'

        #Function Declarations
        @scope.close = @close
        @scope.colorStatus = @colorStatus
        @scope.bulkClear = @bulkClear
        @scope.bulkClearSelectAll = @bulkClearSelectAll
        @scope.handleRowClick = @handleRowClick
        @scope.clearSingle = @clearSingle
        @scope.updateFiles = @updateFiles

        @transitionStart = @transitions.onStart {}, ($transition) =>
            # Close the dialog unless we're switching to confirmation
            @scope.$emit 'data_fullpage:hide' if $transition.to().url isnt '/confirmation'

        @scope.$on '$destroy', () =>
            @cancelBulkClear()
            @transitionStart()

        # listen for resize events and hide the loading message
        $(window).on 'resize', debounce(() =>
            @loader.hideAll()
        )


    colorStatus: (status) =>
        switch status
            when 'Uploading', 'Processing'
                'text-blue'
            when 'Success'
                'text-green'
            when 'Converted'
                'text-orange'
            else
                'text-red'


    cancelBulkClear: () =>
        @scope.clear_selections = []
        @scope.bulkClearing = true
        @bulkClear()


    bulkClear: () =>
        if @scope.clear_selections.length > 0
            @handleBulkClear()
        else
            @scope.bulkClearing = not @scope.bulkClearing
            @scope.selectedAll = if not @scope.bulkClearing then false
            @scope.clearBtnText = if @scope.bulkClearing then 'Cancel Clear' else 'Bulk Clear'

            if @mcs.input_files?
                for file in @mcs.input_files
                    if @scope.cant_clear.indexOf(file.status) is -1 and @scope.bulkClearing
                        file.rowClass = 'multidelete alert-success'
                    else
                        file.rowClass = ''


    handleBulkClear: () =>
        #show the loader
        msg = @loader.overMap 'Loading...'

        # Clear selected records from the front end
        file_ids = []
        for file in @scope.clear_selections
            file_ids.push file.id
            @mcs.clearFile file

        # Hit the back end to update the DB
        @mcs.clearDbInputFiles file_ids
        @scope.clear_selections = []

        @bulkClear()

        $(window).trigger 'resize'
        return true


    bulkClearSelectAll: () =>
        @scope.selectedAll = not @scope.selectedAll
        @scope.clearBtnText = if @scope.selectedAll then 'Clear Selected' else 'Cancel Clear'

        # clear all from clear select (we'll re-add them if needed)
        @scope.clear_selections = []

        # Check each file and modify its css a
        for file in @mcs.input_files

            # Check if the file can be cleared
            file.canClear = @scope.cant_clear.indexOf(file.status) is -1

            if file.canClear
                if @scope.selectedAll
                    file.rowClass = 'multidelete alert-error'
                    @scope.clear_selections.push file
                else
                    file.rowClass = 'multidelete alert-success'


    clearSingle: (file) =>
        msg = @loader.overMap 'Loading...'

        # Clear from the front end
        @mcs.clearFile file

        # Hit back end to update DB
        @mcs.clearDbInputFiles [file.id]

        $(window).trigger 'resize'
        return true


    handleRowClick: (file) =>
        return if not @scope.bulkClearing

        if file.rowClass is 'multidelete alert-success'
            file.rowClass = 'multidelete alert-error'
            @scope.clear_selections.push file

        else if file.rowClass is 'multidelete alert-error'
            file.rowClass = 'multidelete alert-success'
            index = @scope.clear_selections.indexOf file
            @scope.clear_selections.splice index, 1

        @scope.clearBtnText = if @scope.clear_selections.length > 0 then 'Clear Selected' else 'Cancel Clear'


    close: () =>
        @state.go 'grower.data.add'

